/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgBankingControllerGetBankingParamsGen,
  ThgBankingControllerNewBankingParamsGen,
  ThgBankingDtoGen,
  ThgBankingViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Banking<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerGetMyBankingInformation
   * @summary Get my Banking informations
   * @request GET:/banking/me
   * @secure
   * @response `200` `ThgBankingDtoGen` The Bankinginformations of a user
   * @response `400` `void` General error if request is not working.
   */
  bankingControllerGetMyBankingInformation = (params: RequestParams = {}) =>
    this.http.request<ThgBankingDtoGen, void>({
      path: `/banking/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerCreateOrUpdateBankingMe
   * @summary Creates or Update my Bankinginformations
   * @request POST:/banking/me
   * @secure
   * @response `200` `ThgBankingViewModelGen` The record has been successfully created
   * @response `403` `void` Forbidden.
   */
  bankingControllerCreateOrUpdateBankingMe = (data: ThgBankingDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgBankingViewModelGen, void>({
      path: `/banking/me`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerNewBanking
   * @summary Creates BankingInformation for a User
   * @request POST:/banking
   * @secure
   * @response `200` `ThgBankingDtoGen` The record has been successfully created
   * @response `403` `void` Forbidden.
   */
  bankingControllerNewBanking = (
    query: ThgBankingControllerNewBankingParamsGen,
    data: ThgBankingDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgBankingDtoGen, void>({
      path: `/banking`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerGetBanking
   * @summary Gets Banking Information of a User
   * @request GET:/banking
   * @secure
   * @response `200` `ThgBankingDtoGen` The record has been successfully created
   * @response `403` `void` Forbidden.
   */
  bankingControllerGetBanking = (query: ThgBankingControllerGetBankingParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgBankingDtoGen, void>({
      path: `/banking`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
